import { useRef, useState } from "react";
import Container from "~/components/Container";

const ERROR_MESSAGES: Record<string, string> = {
  missing_token: "That sign-in link is missing its token. Please request a new one below.",
  expired_link: "That sign-in link has expired or is invalid. Please request a new one below.",
  unauthorized: "That email no longer has access. Please reach out if you think this is a mistake."
};

export default function InnerCircleAccess() {
  const [success, setSuccess] = useState(false);
  const [signInError, setSignInError] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const emailRef = useRef(null);

  const urlParams = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  const redirectedFrom = decodeURI(urlParams.get("redirectedFrom") ?? "") || undefined;
  const linkError = urlParams.get("error");

  return (
    <Container>
      <div className="w-full min-w-[28rem] max-w-[30rem] self-center p-20 min-h-[24rem]">
        <form
          className="flex flex-col"
          onSubmit={async (event) => {
            event.preventDefault();

            setSuccess(false);
            setHasSubmitted(true);
            setSignInError("");

            try {
              const body = JSON.stringify({
                email: emailRef.current?.value ?? "",
                redirectedFrom
              });

              const result = await fetch("/api/inner-circle/access", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body
              }).then((res) => res.json());

              if (result.error) {
                console.error(result.error);
                setSignInError(typeof result.error === "object" ? result.error.message : result.error);
              } else {
                setSuccess(true);
              }
            } catch (error) {
              console.error(error);
              setSignInError(typeof error === "object" ? error.message : error);
            } finally {
              setHasSubmitted(false);
            }
          }}
        >
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                disabled={hasSubmitted}
                required
                className="appearance-none rounded relative block
                w-full px-3 py-2 border border-gray-300
                placeholder-gray-500 text-current rounded-t-md
                focus:outline-dotted focus:outline-blue focus:z-10 sm:text-sm"
                placeholder="Email address"
                ref={emailRef}
              />
            </div>
          </div>
          <button type="submit" disabled={hasSubmitted} className={`py-2 px-4 p-3 pr-6 mt-4 mb-4`}>
            {hasSubmitted ? "Sending link, please wait..." : "Send sign-in link"}
          </button>
          {success && (
            <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
              <p className="font-bold">Check your email for a sign-in link</p>
              <p className="text-sm">You may try again, or close this tab now.</p>
            </div>
          )}
          {(signInError || linkError) && (
            <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" role="alert">
              <p className="font-bold">Attention</p>
              <p>{signInError || ERROR_MESSAGES[linkError] || "Something went wrong. Please try again."}</p>
            </div>
          )}
        </form>
      </div>
    </Container>
  );
}
